import type { ReactNode } from 'react'
import React, { PureComponent } from 'react'

import { getDataSelector } from '@vfuk/core-base-props'

import FieldWrapper from '@vfuk/core-field-wrapper'
import SelectInputWithMenu from '@vfuk/core-select-input-with-menu'

import type { SelectInputWithMenuWithLabelProps, GetStateReturn } from './SelectInputWithMenuWithLabel.types'

class SelectInputWithMenuWithLabel extends PureComponent<SelectInputWithMenuWithLabelProps> {
  private getState = <T extends 'fieldWrapper' | 'selectInputWithMenu'>(type: T): GetStateReturn<T> | undefined => {
    if (type === 'fieldWrapper') return this.props.state !== 'disabled' ? (this.props.state as GetStateReturn<T>) : undefined

    if (type === 'selectInputWithMenu') return this.props.state !== 'info' ? (this.props.state as GetStateReturn<T>) : undefined
  }

  public componentName = 'SelectInputWithMenuWithLabel'

  public render(): ReactNode {
    return (
      <FieldWrapper
        {...this.props.fieldWrapper}
        dataAttributes={this.props.dataAttributes}
        id={this.props.id}
        state={this.getState('fieldWrapper')}
        formElementId={this.props.selectInputWithMenu.id}
        renderAsLabel={false}
        dataSelectorPrefix={getDataSelector(this.props.dataSelectorPrefix)}
        componentName={this.componentName}
      >
        <SelectInputWithMenu
          {...this.props.selectInputWithMenu}
          state={this.getState('selectInputWithMenu')}
          dataSelectorPrefix={getDataSelector(this.props.dataSelectorPrefix, 'select-input-with-menu')}
        >
          {this.props.selectInputWithMenu.children}
        </SelectInputWithMenu>
      </FieldWrapper>
    )
  }
}

export default SelectInputWithMenuWithLabel
